import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "./ui/spinner";
import { changeStepper } from "./preAfiliado/stepper";
import { startAlerta } from "./ui/alertas";

export const preAfiliacionesTomadasTraerStart = () => ({ type: types.preAfiliacionesTomadasTraerStart });
export const preAfiliacionesTomadasLimpiar = () => ({ type: types.preAfiliacionesTomadasLimpiar });
export const preAfiliacionesTomadasTraerError = (error) => ({ type: types.preAfiliacionesTomadasTraerError,payload: error});
export const preAfiliacionesTomadasLiberar = (payload) => ({ type: types.preAfiliacionesTomadasLiberar, payload: payload});
export const preAfiliacionesTomadasUsuarioLiberar = (payload) => ({ type: types.preAfiliacionesTomadasUsuarioLiberar, payload: payload});
export const preAfiliacionesTomadasTraerSuccess = (payload) => {
  return {
    type: types.preAfiliacionesTomadasTraerSuccess,
    payload: payload
  }
}
export const preAfiliacionesTomadasUsuarioTraerSuccess = (payload) => {
  return {
    type: types.preAfiliacionesTomadasUsuarioTraerSuccess,
    payload: payload
  }
}
export const preAfiliacionesTomadasUsuarioAgregar = (payload) => {
  return {
    type: types.preAfiliacionesTomadasUsuarioAgregar,
    payload: payload
  }
}
  
export const fetchPreAfilicionesTomadasPorUsuario = (idUsuario) => {
    return async (dispatch) => {
     dispatch(startSpinner());
        dispatch(preAfiliacionesTomadasTraerStart());
      const response = await fetchConToken(`PreAfiliacionesTomadas/traerPorUsuario/${idUsuario}`);
      if (!response.ok) {
          dispatch(preAfiliacionesTomadasTraerError(response.statusText));
        throw Error(response.statusText);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        dispatch(preAfiliacionesTomadasUsuarioTraerSuccess(lista));
      }
     dispatch(finishSpinner());
    };
  };

export const fetchPreAfilicionesTomadas = () => {
  return async (dispatch) => {
    dispatch(startSpinner());
      dispatch(preAfiliacionesTomadasTraerStart());
    const response = await fetchConToken(`PreAfiliacionesTomadas/traerTomadas`);
    if (!response.ok) {
        dispatch(preAfiliacionesTomadasTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      dispatch(preAfiliacionesTomadasTraerSuccess(lista));
    }
    dispatch(finishSpinner());
  };
};

export const liberarPreAfiliacion = (id, userType = 'user') => async (dispatch) => {
  const response = await fetchConToken(
    `PreAfiliacionesTomadas`,
    { id },
    "PUT"
  );
  if (!response.ok) {
    throw Error(response.statusText);
  }
  if(userType === 'user')
    dispatch(preAfiliacionesTomadasUsuarioLiberar(id));
  else if(userType === 'admin')
    dispatch(preAfiliacionesTomadasLiberar(id));
}

export const tomarPreAfiliacion = (idUsuario, preAfiliacion) => async (dispatch) => {
  const response = await fetchConToken(
    `PreAfiliacionesTomadas`,
    { idUsuario: idUsuario, idGrupoFamiliar: preAfiliacion.idGrupoFamiliar },
    "POST"
  );
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.indexOf("application/json") !== -1) {
    const registro = await response.json();
    if (!response.ok) {
      dispatch(changeStepper(0));
      dispatch( startAlerta(registro.errores, "warning", `¡Error!`) );
    }else{
      if(registro.idGrupoFamiliar !== 0)
        dispatch(preAfiliacionesTomadasUsuarioAgregar(registro));
      dispatch({
        type: types.consultaTraerAfiliadoPorCuil,
        payload: preAfiliacion,
      });
    }
    dispatch(finishSpinner());
  }
}